<template>
  <div class="loginDialog">
        <Head>
          <link head-key="font-montserrat" href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&display=swap" rel="stylesheet" />
        </Head>
        <div v-if="type == 'register'" class="auth">
          <div class="auth__head">
            <button type="button" class="auth__close" aria-label="Close" @click="$emit('closeLoginDialog')">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" /></svg>
            </button>
            <h2 class="auth__title">Signup for free and join Ireland's largest Returner Community</h2>
          </div>

          <form class="auth__body" novalidate @submit.prevent="register">
            <label class="auth__label" :for="uid + '-name'">Name</label>
            <input :id="uid + '-name'" v-model="registerform.name" class="auth__input" type="text" autocomplete="name" placeholder="Your full name" />

            <label class="auth__label" :for="uid + '-email'">Email</label>
            <input
              :id="uid + '-email'"
              v-model="registerform.email"
              class="auth__input"
              :class="{ 'is-invalid': emailError }"
              type="email"
              autocomplete="email"
              placeholder="you@example.com"
              :aria-invalid="emailError ? 'true' : null"
              :aria-describedby="emailError ? uid + '-email-error' : null"
              @input="registerErrors.email = null"
              @change="updatevalidate()"
              @blur="touched.email = true"
            />
            <p v-if="emailError" :id="uid + '-email-error'" class="auth__error" role="alert">{{ emailError }}</p>

            <label class="auth__label" :for="uid + '-password'">Password</label>
            <div class="auth__password">
              <input
                :id="uid + '-password'"
                v-model="registerform.password"
                class="auth__input"
                :class="{ 'is-invalid': passwordError }"
                :type="showPassword ? 'text' : 'password'"
                :autocomplete="new_account ? 'new-password' : 'current-password'"
                placeholder="At least 8 characters"
                :aria-invalid="passwordError ? 'true' : null"
                :aria-describedby="passwordError ? uid + '-password-error' : null"
                @input="registerErrors.password = null"
                @blur="touched.password = true"
              />
              <button type="button" class="auth__show" :aria-pressed="showPassword ? 'true' : 'false'" @click="showPassword = !showPassword">{{ showPassword ? 'Hide' : 'Show' }}</button>
            </div>
            <p v-if="passwordError" :id="uid + '-password-error'" class="auth__error" role="alert">{{ passwordError }}</p>

            <!-- Only new accounts are asked to accept the terms; an existing
                 member signing in is not (see updatevalidate). -->
            <label v-if="require_terms" class="auth__check">
              <input v-model="registerform.terms" type="checkbox" />
              <span class="auth__box" aria-hidden="true"></span>
              <span>I agree to the <a href="#" @click.prevent="termsandconditions = true">Terms and Conditions</a> and I have viewed the <a href="#" @click.prevent="privacypolicy = true">Privacy Policy</a>.</span>
            </label>
            <label class="auth__check">
              <input v-model="registerform.newsletter" type="checkbox" />
              <span class="auth__box" aria-hidden="true"></span>
              <span>Yes, please sign me up for the BTWC Newsletter to get the latest jobs and information directly to my email.</span>
            </label>

            <p v-if="registerErrors.general" class="auth__error auth__error--general" role="alert">{{ registerErrors.general }}</p>
            <button type="submit" class="auth__submit" :disabled="registerDisabled" :aria-busy="registerform.processing ? 'true' : 'false'">
              {{ registerform.processing ? 'Please wait…' : 'Register or Sign-in' }}
            </button>
            <a class="auth__forgot" :href="baseurl + '/forgotpassword'">Forgot your password?</a>

            <div class="auth__divider"><span>Or continue with</span></div>
            <div class="auth__social">
              <a :href="baseurl + '/auth/google?state=' + state + '&action=' + action">
                <svg width="26" height="26" viewBox="0 0 48 48" aria-hidden="true"><path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z" /><path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z" /><path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-8l-6.5 5C9.5 39.6 16.2 44 24 44z" /><path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.4-.4-3.5z" /></svg>
                Google
              </a>
              <span class="auth__social-sep" aria-hidden="true"></span>
              <a :href="fburl">
                <svg width="26" height="26" viewBox="0 0 24 24" aria-hidden="true"><path fill="#1877F2" d="M13.5 21v-7.5h2.6l.4-3.1h-3V8.5c0-.9.3-1.5 1.5-1.5h1.6V4.2c-.3 0-1.2-.1-2.3-.1-2.3 0-3.9 1.4-3.9 4v2.3H7.8v3.1h2.6V21h3.1z" /></svg>
                Facebook
              </a>
            </div>
          </form>
        </div>
        <v-card class="px-4" v-if="type == 'login'">
            <v-card-text>
                <v-form ref="loginref" lazy-validation class="bg-white rounded-lg shadow-xl overflow-hidden" @submit.prevent="login" >
                    <div class="px-5 py-12">
                    <h1 class="text-center text-3xl font-bold">Welcome back!</h1>
                    <div class="mt-6 mx-auto w-24 border-b-2" />
                    <v-text-field validate-on-blur :rules="emailRules" v-model="loginform.email" :error-messages="loginErrors.email" label="Email" type="email" required="true"></v-text-field>
                    <v-text-field validate-on-blur :rules="passwordRules" v-model="loginform.password" :error-messages="loginErrors.password" label="Password" type="Password" required="true"></v-text-field>
                    <label class="flex items-center mt-6 select-none" for="remember">
                        <v-checkbox id="remember" v-model="loginform.remember" class="mr-1" type="checkbox" />
                        <span class="text-sm">Remember Me</span>
                    </label>
                    <v-container>
                      <v-row>
                      <v-col
                        cols="12"
                        sm="12" class="text-center">
                    <v-btn :loading="loginform.processing" class="btn-indigo ml-auto" type="submit">Login
                    </v-btn>
                  </v-col>
                  <v-col
                        cols="12"
                        sm="6" class="text-center">
                    <a type="button" :href="baseurl+'/auth/google?state='+state+'&action='+action">
                        <img :src="baseurl + '/img/google_signin_buttons/web/2x/btn_google_signin_light_focus_web@2x.png'" style="height:40px">
                    </a>
                  </v-col>
                  <v-col
                        cols="12"
                        sm="6" class="text-center">

                    <a type="button" :href="fburl">
                      <img :src="baseurl + '/img/facebook_signin_buttons/button1.png'"  style="height:40px">
                    </a>
                    </v-col>
                    <v-col
                        cols="12"
                        sm="12" class="text-center">
                    <h3>Need to signup? <b @click='type = "register"' style="cursor:pointer">Register for free.</b></h3>
                    </v-col>
                    </v-row>
                    </v-container>
                  </div>
                </v-form>
            </v-card-text>
        </v-card>
        <!-- Terms and Privacy open over the popup: full screen on phones. -->
        <v-dialog v-model="termsandconditions" max-width="760" :fullscreen="$vuetify.breakpoint.xsOnly" content-class="legalDialog" overlay-color="#322132" overlay-opacity="0.6">
          <LegalDocument v-if="termsandconditions" v-bind="legal.terms" @close="termsandconditions = false" />
        </v-dialog>
        <v-dialog v-model="privacypolicy" max-width="760" :fullscreen="$vuetify.breakpoint.xsOnly" content-class="legalDialog" overlay-color="#322132" overlay-opacity="0.6">
          <LegalDocument v-if="privacypolicy" v-bind="legal.privacy" @close="privacypolicy = false" />
        </v-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import { Head } from '@inertiajs/inertia-vue'
import LegalDocument from '@/Shared/LegalDocument'
import legalDocuments from '@/Shared/legalDocuments'

export default {
  props: {
    loading: Boolean,
    errors: Object,
    state: String,
    action: String,
    baseurl: String,
    redirectHome: Boolean
  },
  components: {
    Head,
    LegalDocument,
  },
  data() {
    return {
        type: 'register',
        legal: Object.freeze(legalDocuments), // static text: no reactivity needed
        termsandconditions:false,
        privacypolicy:false,
        loginform: this.$inertia.form({
            action: this.action,
            email: null,
            password: null,
            remember: false,
        }),
        registerform: this.$inertia.form({
            action: this.action,
            name: null,
            email: null,
            password: null,
            remember: false,
            terms: false,
            ctoken: null,
            newsletter: true,
        }),
        validateform: this.$inertia.form({ 
          email: null
        }),
        registerErrors: {
          email: null,
          password: null,
          general: null
        },
        loginErrors: {
          email: null,
          password: null
        },
        emailRules: [
          v => !!v || 'E-mail is required',
          v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        ],
        passwordRules: [
          (value) => !!value || 'Please type a password.',
          (value) => (value && value.length >= 6) || 'minimum 6 characters',
        ],
        fburl: 'https://www.facebook.com/v15.0/dialog/oauth?client_id=1550219925424690&scope=email%2Cpublic_profile&redirect_uri=https%3A%2F%2Fbacktoworkconnect.ie%2Fcallback%2Ffacebook&state='+this.state+'&action='+this.action,
        require_terms: true,
        term_require_checked: false,
        terms:false,
        recaptcha_success:false,
        showPassword: false,
        new_account: false,
        touched: { email: false, password: false },
    }
  },
  computed: {
    uid() {
      return 'auth-' + this._uid
    },
    // Messages show once a field has been left, or when the server rejects it.
    emailError() {
      if (this.registerErrors.email) return this.registerErrors.email
      const v = this.registerform.email
      return this.touched.email && v && !/.+@.+\..+/.test(v) ? 'Please enter a valid email address.' : ''
    },
    // New accounts need 8+ characters. Existing members sign in through this
    // same form and keep whatever password they have, including the many who
    // have not accepted the terms yet (require_terms is true for them too).
    passwordError() {
      if (this.registerErrors.password) return this.registerErrors.password
      const v = this.registerform.password
      return this.touched.password && this.new_account && v && v.length < 8 ? 'Use at least 8 characters.' : ''
    },
    registerDisabled() {
      const f = this.registerform
      return !this.term_require_checked || !f.email || !f.password || f.processing ||
        (this.require_terms && !f.terms) ||
        (this.new_account && f.password.length < 8)
    },
    passwordMatch() {
      return () => this.password === this.verify || "Password must match";
    }
  },
  mounted() {
    let recaptchaScript = document.createElement("script");
    recaptchaScript.setAttribute(
      "src",
      "https://www.google.com/recaptcha/api.js?render=6LeLKfUmAAAAAB_-vizMTWYYc-jwLnjSG0fQ3BWm"
    );
    recaptchaScript.setAttribute("async", "true");
    recaptchaScript.setAttribute("defer", "true");
    document.head.appendChild(recaptchaScript);
  },
  watch: {
      action: {
        deep: true,
        handler: function () {
         this.loginform.action = this.action
         this.registerform.action = this.action
         this.fburl = 'https://www.facebook.com/v15.0/dialog/oauth?client_id=1550219925424690&scope=email%2Cpublic_profile&redirect_uri=https%3A%2F%2Fbacktoworkconnect.ie%2Fcallback%2Ffacebook&state='+this.state+'&action='+this.action
        }
      },
    },
  methods: {
    recaptchaSuccess() {
      this.recaptcha_success = true
    },
    recaptchaError() {
      this.recaptcha_success = false;
    },
    updatevalidate() {
      this.term_require_checked = false;
      if (/.+@.+\..+/.test(this.registerform.email))
      {
        this.validateform.email = this.registerform.email
        const formData = new FormData();
        formData.append('email',this.registerform.email);
        
        axios.post(this.baseurl+"/validateRegistrationEmail",formData).then((response) => {
            console.log('edit got response',response)
            if (response && response.data == 0)
              this.require_terms = false
            else
              this.require_terms = true
            // 1 = email not registered yet; 2 = member who hasn't accepted the terms.
            this.new_account = !!response && response.data == 1

            this.term_require_checked = true;
        });
        
      }
    },
    login() {
      console.log('login',this.loginform,this.action,this.baseurl+'/login')
      this.loginform.post(this.baseurl+'/login', {
        onSuccess: (res) => {
          if (this.redirectHome) {
            window.location.href = this.baseurl;
            return;
          }

          this.$emit('toggleDialog');
        },
        onError: (res) => {
            this.loginErrors.email = (res && res.email) ? res.email : ''
            this.loginErrors.password = (res && res.password) ? res.password : ''
        },
      })
    },
    register() {
      console.log('register',this.registerform,this.action,this.baseurl+'/register')
      let ctoken = ""
      let vm = this;
        grecaptcha.ready(function() {
          grecaptcha.execute('6LeLKfUmAAAAAB_-vizMTWYYc-jwLnjSG0fQ3BWm', {action: 'submit'}).then(function(token) {
              // Add your logic to submit to your backend server here.
              console.log('got token',token)
              if (token) {
                vm.registerform.ctoken = token;
                  vm.registerform.post(vm.baseurl+'/register', {
                    onSuccess: (res) => {
                      console.log('registerform onsuccess',res,vm.errors)
                      if (vm.redirectHome) {
                        window.location.href = vm.baseurl;
                        return;
                      }
                      vm.$emit('toggleDialog');
                    },
                    onError: (res) => {
                        vm.registerErrors.email = (res && res.email) ? res.email : ''
                        vm.registerErrors.password = (res && res.password) ? res.password : ''
                        // The server answers a failed reCAPTCHA with 'register'; say so
                        // rather than leave the button doing nothing.
                        vm.registerErrors.general = (res && res.register) ? "Sorry, that didn't go through. Please try again." : ''
                    },
                  })
                }
          });
        });

        
    },

    getErrors(s) {
      if (this.errors)
        console.log('get errors',s,this.errors,this.errors[s])
        if (this.errors && this.errors[s])
            return this.errors[s]
        else
            return ""
    }
  }
  
}
</script>

<style scoped>
/* Sign-up / sign-in card. Shown in the login dialog on every page (the
   dialog's size and corners are in app.css, .v-dialog.loginDialog) and on
   the /signup page. Sized so the whole card fits on a laptop screen
   (about 700px tall) without scrolling; shorter screens and phones tighten
   further below. */
.auth {
  max-width: 600px;
  margin: 0 auto;
  overflow: hidden;
  border-radius: 28px;
  background: #FFFFFF;
  box-shadow: 0 12px 40px rgba(42, 0, 40, .10);
  font-family: 'Montserrat', sans-serif;
  line-height: normal;
  color: #3F3A32;
  -webkit-font-smoothing: antialiased;
}
.auth__head {
  position: relative;
  padding: 22px 56px;
  background: #F2EEE8;
  text-align: center;
}
.auth__close {
  position: absolute;
  top: 14px;
  right: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: 0;
  border-radius: 50%;
  background: #FFFFFF;
  color: #4A4239;
  cursor: pointer;
  transition: background-color .15s;
}
.auth__close:hover {
  background: #F6EFF5;
}
.auth__title {
  max-width: 440px;
  margin: 0 auto;
  font-size: 21px;
  font-weight: 700;
  line-height: 1.28;
  color: #560354;
  text-wrap: balance;
}
.auth__body {
  display: flex;
  flex-direction: column;
  padding: 24px 40px;
}
.auth__label {
  margin: 12px 0 6px;
  font-size: 14px;
  font-weight: 700;
  color: #3F3A32;
}
.auth__label:first-child {
  margin-top: 0;
}
.auth__input {
  display: block;
  width: 100%;
  height: 46px;
  padding: 0 16px;
  border: 1px solid #E6E0D9;
  border-radius: 12px;
  background: #FFFFFF;
  font: 16px 'Montserrat', sans-serif;
  color: #3F3A32;
  transition: border-color .15s, box-shadow .15s;
}
.auth__input::placeholder {
  color: #9A9287;
  opacity: 1;
}
.auth__input:focus {
  outline: none;
  border-color: #560354;
  box-shadow: 0 0 0 3px rgba(86, 3, 84, .15);
}
.auth__input.is-invalid {
  border-color: #B3261E;
}
.auth__password {
  position: relative;
}
.auth__password .auth__input {
  padding-right: 72px;
}
.auth__show {
  position: absolute;
  top: 50%;
  right: 6px;
  height: 36px;
  padding: 0 10px;
  border: 0;
  border-radius: 8px;
  background: none;
  font: 700 15px 'Montserrat', sans-serif;
  color: #560354;
  cursor: pointer;
  transform: translateY(-50%);
}
.auth__show:hover {
  background: #F6EFF5;
}
.auth__error {
  margin: 6px 0 0;
  font-size: 13px;
  color: #B3261E;
}
.auth__error--general {
  margin-top: 12px;
  text-align: center;
}
.auth__check {
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-top: 14px;
  font-size: 14.5px;
  line-height: 1.45;
  color: #675B46;
  cursor: pointer;
}
.auth__check + .auth__check {
  margin-top: 8px;
}
/* The real checkbox stays in place (invisible) for keyboard and screen
   readers; .auth__box draws it. */
.auth__check input {
  position: absolute;
  top: 0;
  left: 0;
  width: 22px;
  height: 22px;
  margin: 0;
  opacity: 0;
  cursor: pointer;
}
.auth__box {
  flex: 0 0 22px;
  height: 22px;
  border: 1.5px solid #8A8074;
  border-radius: 5px;
  background: #FFFFFF center / 14px no-repeat;
  transition: background-color .15s, border-color .15s;
}
.auth__check input:checked + .auth__box {
  border-color: #560354;
  background-color: #560354;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='3.2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M5 12.5l4.5 4.5L19 7.5'/%3E%3C/svg%3E");
}
.auth__check a {
  font-weight: 700;
  color: #560354;
  text-decoration: underline;
  text-decoration-thickness: 2px;
  text-underline-offset: 3px;
}
.auth__submit {
  height: 50px;
  margin-top: 16px;
  border: 0;
  border-radius: 999px;
  background: #560354;
  font: 700 17px 'Montserrat', sans-serif;
  color: #FFFFFF;
  cursor: pointer;
  transition: background-color .15s, color .15s;
}
.auth__submit:hover:not(:disabled) {
  background: #42003F;
}
.auth__submit:disabled {
  background: #EEEAE5;
  color: #A89F95;
  cursor: not-allowed;
}
.auth__forgot {
  align-self: center;
  margin-top: 8px;
  padding: 2px 4px;
  font-size: 15px;
  font-weight: 700;
  color: #560354;
  text-decoration: none;
}
.auth__forgot:hover {
  text-decoration: underline;
}
.auth__divider {
  display: flex;
  align-items: center;
  gap: 16px;
  margin: 12px 0 10px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: .16em;
  text-transform: uppercase;
  color: #8A8074;
}
.auth__divider::before,
.auth__divider::after {
  content: '';
  flex: 1;
  height: 1px;
  background: #E6E0D9;
}
.auth__social {
  display: flex;
  align-items: center;
  height: 48px;
  overflow: hidden;
  border: 1px solid #E6E0D9;
  border-radius: 999px;
}
.auth__social a {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  gap: 10px;
  height: 100%;
  font-size: 16px;
  font-weight: 600;
  color: #3F3A32;
  text-decoration: none;
  transition: background-color .15s;
}
.auth__social a:hover {
  background: #FAF7F4;
}
.auth__social svg {
  width: 22px;
  height: 22px;
}
.auth__social-sep {
  flex: none;
  width: 1px;
  height: 28px;
  background: #E6E0D9;
}
.auth button:focus-visible,
.auth a:focus-visible,
.auth__check input:focus-visible + .auth__box {
  outline: 3px solid #C99BC7;
  outline-offset: 2px;
}

/* Short screens (1366x768 laptops): tighten again so it still fits. */
@media (max-height: 760px) {
  .auth__head {
    padding: 12px 52px 10px;
  }
  .auth__title {
    font-size: 19px;
  }
  .auth__body {
    padding: 18px 40px 20px;
  }
  .auth__label {
    margin-top: 10px;
  }
  .auth__input {
    height: 40px;
  }
  .auth__check {
    margin-top: 12px;
    font-size: 14px;
    line-height: 1.4;
  }
  .auth__submit {
    height: 46px;
    margin-top: 14px;
  }
  .auth__divider {
    margin: 10px 0 8px;
  }
  .auth__social {
    height: 44px;
  }
}

/* Shorter still (1280x720, phones held upright). */
@media (max-height: 640px), (max-width: 600px) and (max-height: 700px) {
  .auth__head {
    padding: 14px 52px 12px;
  }
  .auth__title {
    font-size: 18px;
  }
  .auth__body {
    padding: 14px 40px 16px;
  }
  .auth__label {
    margin: 8px 0 4px;
    font-size: 13px;
  }
  .auth__check {
    margin-top: 10px;
    font-size: 13.5px;
  }
  .auth__check + .auth__check {
    margin-top: 6px;
  }
  .auth__submit {
    height: 44px;
    margin-top: 12px;
    font-size: 16px;
  }
  .auth__forgot {
    margin-top: 4px;
    font-size: 14px;
  }
  .auth__divider {
    margin: 6px 0 6px;
  }
  .auth__social {
    height: 42px;
  }
}

/* Smallest screens (iPhone SE): a plain rule stands in for the "Or
   continue with" label, and spacing tightens once more. */
@media (max-height: 580px) {
  .auth__head {
    padding: 10px 48px 8px;
  }
  .auth__title {
    font-size: 16.5px;
  }
  .auth__body {
    padding-top: 10px;
    padding-bottom: 8px;
  }
  .auth__check + .auth__check {
    margin-top: 4px;
  }
  .auth__label {
    margin: 6px 0 3px;
  }
  .auth__input {
    height: 38px;
  }
  .auth__check {
    font-size: 13px;
    line-height: 1.35;
  }
  .auth__submit {
    height: 42px;
    margin-top: 8px;
  }
  .auth__divider {
    margin: 6px 0;
    font-size: 0;
    gap: 0;
  }
  .auth__social {
    height: 40px;
  }
}

/* Phones: narrower padding; inputs stay at 16px so iOS Safari does not
   zoom the page when one is focused. */
@media (max-width: 600px) {
  .auth {
    border-radius: 22px;
  }
  .auth__head {
    padding-right: 52px;
    padding-left: 52px;
  }
  .auth__title {
    font-size: 18px;
  }
  .auth__close {
    top: 10px;
    right: 10px;
  }
  .auth__body {
    padding-right: 20px;
    padding-left: 20px;
  }
}
</style>
